import { IconProps } from "../../utils/global-types/global-types";

const AddIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M9 2.333C5.327 2.333 2.333 5.327 2.333 9S5.327 15.667 9 15.667 15.667 12.673 15.667 9 12.673 2.333 9 2.333M11.667 9.5H9.5v2.167c0 .273-.227.5-.5.5a.504.504 0 0 1-.5-.5V9.5H6.333a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5H8.5V6.333c0-.273.227-.5.5-.5s.5.227.5.5V8.5h2.167c.273 0 .5.227.5.5s-.227.5-.5.5"
      ></path>
    </svg>
  );
};

export default AddIcon;
